
import { Component, Vue } from 'vue-property-decorator'
import authModule from '@/store/auth'
import companyModule from '@/store/company'
import PartnerList from '@/components/company/partner/PartnerList.vue'
import CompanyEditor from '@/components/company/CompanyEditor.vue'

@Component({
  name: 'CompanyList',
  components: {
    PartnerList,
    CompanyEditor
  }
})
class CompanyDetail extends Vue {
  private get storeModule() {
    return companyModule
  }

  private get auth() {
    return authModule
  }

  private get company() {
    return companyModule.company
  }

  private async created(): Promise<void> {
    if (!this.company) {
      await companyModule.fetch(this.$route.params.cid)
    }
  }
}

export default CompanyDetail
